import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import {createPortal} from "react-dom";

import Button from "@khanacademy/wonder-blocks-button";
import {semanticColor} from "@khanacademy/wonder-blocks-tokens";
import {a11yStyles} from "@khan/shared-styles";

const getSkipToTargetMount = (): HTMLElement => {
    const NODE_ID = "skip-to-target-mount";
    const existingNode = document.getElementById(NODE_ID);
    if (existingNode) {
        return existingNode;
    }

    const skipToMountingNode = document.createElement("div");
    skipToMountingNode.id = NODE_ID;
    // We don't want this node to be tabbable.
    skipToMountingNode.tabIndex = -1;
    return skipToMountingNode;
};

const getOrCreateAndMountSkipToKhanmigoMount = (): HTMLElement => {
    const NODE_ID = "skip-to-khanmigo-mount";
    const existingNode = document.getElementById(NODE_ID);
    if (existingNode) {
        return existingNode;
    }

    // Mount the skip link where the other skip to links are mounted.
    const skipToTargetMount = getSkipToTargetMount();
    const skipToKhanmigoMount = document.createElement("div");
    skipToKhanmigoMount.id = NODE_ID;
    skipToTargetMount.appendChild(skipToKhanmigoMount);
    return skipToKhanmigoMount;
};

/**
 * A skip link to assist tab navigation in finding Khanmigo.
 * We only want to render this skip link on pages where the Khanmigo
 * popover UI is available.
 */
export const SkipToKhanmigoLink = ({onToggle}): React.ReactElement =>
    createPortal(
        <Button
            style={[a11yStyles.skipToMain, styles.skipLink]}
            onClick={onToggle}
        >
            {t`Skip to Khanmigo button`}
        </Button>,
        getOrCreateAndMountSkipToKhanmigoMount(),
    );

const styles = StyleSheet.create({
    skipLink: {
        color: semanticColor.core.foreground.instructive.default,
        flexDirection: "row",
        flexWrap: "nowrap",
        minInlineSize: 250,
        ":active": {
            background: semanticColor.core.background.base.default,
        },
    },
});
